export default class DataGender{
  arrayGender: string[];
  constructor(){
    this.arrayGender = [
      "Laki-laki",
      "Perempuan",
      "Lainnya",]
  }
}